import styled from "@emotion/styled";
import { SkeletonBlock } from "components/general/Skeleton";
import { useIsMobile } from "hooks/useDeviceType";
import { useIsTradeHistoryReturned } from "hooks/useIsTradeHistoryReturned";
import { TransactionDetail } from "../../../types/history";
import { formatToDesiredDisplayDate } from "../../../utils/dateUtils";

export const TimestampCell = ({ timestamp }: { timestamp: TransactionDetail["timestamp"] }) => {
  const isMobile = useIsMobile();
  const isTradeHistoryReturned = useIsTradeHistoryReturned();

  return (
    <Timestamp isMobile={isMobile}>
      {isTradeHistoryReturned ? (
        formatToDesiredDisplayDate(timestamp)
      ) : (
        <SkeletonBlock width={108} />
      )}
    </Timestamp>
  );
};

// Sub-components

interface TimestampProps {
  isMobile: boolean;
}

const Timestamp = styled.div<TimestampProps>`
  min-width: 108px;
  width: 100%;
  white-space: nowrap;
  color: ${props => props.theme.font.secondary.default};
  font-size: ${props => (props.isMobile ? props.theme.fontSize[4] : props.theme.fontSize[5])};
  line-height: ${props => props.theme.lineHeights[6]};
`;
